import { HTMLProps } from 'react'
import clsx from 'clsx'

export interface LabelProps extends HTMLProps<HTMLLabelElement> {}

export const Label = ({ className, ...rest }: LabelProps): JSX.Element => (
  <label
    className={clsx(className, 'text-s', 'font-medium', 'mb-4')}
    {...rest}
  />
)
